import React from 'react';

import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

import './FurnitureConfigurator.scss';

const FurnitureConfigurator = ( { id, url, className } ) => {
  // Check that we have everything we need to proceed.
  if ( !url ) return null;

  return (
    <div id={id} className={`furnitureConfigurator ${className}`}>
      <LoadingSpinner />
      <iframe title="Furniture Configurator" className="furnitureConfigurator__iframe" src={url} />
    </div>
  );
};

export default FurnitureConfigurator;
